import React, { createContext, useContext, useReducer } from 'react';
import { func, object, shape } from 'prop-types';
import { GuidedRegReducer, initialGuidedRegState } from './reducer';
export const GuidedRegContext = createContext();

export const GuidedRegProvider = props => {
    const reducer = props.reducer || GuidedRegReducer();
    const guidedRegInitState = props.initialState || initialGuidedRegState;
    const [guidedRegState, guidedRegDispatch] = useReducer(reducer, guidedRegInitState);
    return (
        <GuidedRegContext.Provider value={[guidedRegState, guidedRegDispatch]}>
            {props.children}
        </GuidedRegContext.Provider>
    );
};

GuidedRegProvider.propTypes = {
    reducer: func,
    initialGuidedRegState: shape({
        rates: object
    })
};

export const useGuidedRegContext = () => useContext(GuidedRegContext);
